import { LOCALE } from '../constants';

export const getDisplayPrice = (price) => {

  const holidayFinderLocaleDisplayedPrice = (locale, currency, price, market) => {
    // we do that becuase in RTL site we still want the currency on left side
    locale = (locale === "he" || locale === "HE") ? "en" : locale;

    let newFormatPrice = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
    })
      .format(price)
      .replace(' ', '')
      .replace(' ', '');

    return newFormatPrice;
  };

  return !!window.localeDisplayedPrice
    ? window.localeDisplayedPrice(
        LOCALE,
        window.holidayFinder.currency,
        price,
        window.holidayFinder.market
      )
    : holidayFinderLocaleDisplayedPrice(
      LOCALE,
      window.holidayFinder.currency,
      price,
      window.holidayFinder.market
      );

  // return window.localeDisplayedPrice(
  //   window.holidayFinder.locale,
  //   window.holidayFinder.currency,
  //   price,
  //   window.holidayFinder.market
  // );
};
